import type { ReactElement } from 'react';

/** 제출 버튼 오른쪽 화살표 — 꾸밈이라 버튼 이름에서 뺀다. */
export const SubmitArrow = (): ReactElement => (
  <span aria-hidden className="text-lg leading-none">
    →
  </span>
);
